/*
 * assets/frenly-auction-cadence.js
 * NEW 2026-09-05 (v2.27, Part 4 "Goldin auction preview polish").
 *
 * Shared cadence math, ported verbatim from the inline script in
 * snippets/frenly-auction-duo.liquid (brisbane, finalSaturdayMega,
 * currentMega, currentWeekly) so other surfaces (the Ending Soon rail, the
 * Hottest lots rail, the full auction-room grid and lot detail panel) can
 * classify a lot's end time into the same weekly/mega event windows without
 * duplicating the date math. This file has no dependencies and does not
 * touch the DOM. It is safe to load more than once: it only ever assigns
 * window.FrenlyCadence to a fresh object built from these pure functions.
 *
 * Marshall's locked cadence rule: MEGA always closes on the final Saturday
 * of the month from 4pm to 7pm Gold Coast time, and opens ten days before
 * that (Wednesday 4pm). WEEKLY opens every Saturday 4pm to 7pm and closes
 * the next Saturday in the same window, except the wave that would close
 * on the mega Saturday, which the mega replaces. Brisbane has no daylight
 * saving, so 4pm and 7pm AEST are fixed UTC+10 offsets.
 */
(function (root) {
  var HOUR = 3600000, DAY = 86400000;

  var brisbane = function (y, m, d, h) { return Date.UTC(y, m, d, h - 10, 0, 0, 0); };

  var finalSaturdayMega = function (y, m) {
    var lastDay = new Date(Date.UTC(y, m + 1, 0));
    var d = lastDay.getUTCDate();
    var dow = new Date(Date.UTC(y, m, d)).getUTCDay();
    d -= (dow + 1) % 7;
    var end = brisbane(y, m, d, 19);
    var start = end - 10 * DAY - 3 * HOUR;
    return { start: start, end: end };
  };

  var currentMega = function (now) {
    var probe = new Date(now + 10 * HOUR);
    var y = probe.getUTCFullYear(), m = probe.getUTCMonth();
    var mega = finalSaturdayMega(y, m);
    if (now >= mega.end) { m += 1; if (m > 11) { m = 0; y += 1; } mega = finalSaturdayMega(y, m); }
    return mega;
  };

  var currentWeekly = function (now, mega) {
    var anchor = brisbane(2026, 8, 5, 16); // first weekly window: 5 Sep 2026, 4pm Brisbane
    var sameDay = function (a, b) { return Math.floor((a + 10 * HOUR) / DAY) === Math.floor((b + 10 * HOUR) / DAY); };
    var megaEndsOn = function (end) {
      var probe = new Date(end + 10 * HOUR);
      var mg = finalSaturdayMega(probe.getUTCFullYear(), probe.getUTCMonth());
      return sameDay(mg.end, end);
    };
    for (var k = 0; k < 600; k += 1) {
      var start = anchor + k * 7 * DAY;
      var end = start + 7 * DAY + 3 * HOUR;
      if (end <= now) continue;
      if (megaEndsOn(end)) continue;
      return { start: start, end: end };
    }
    return null;
  };

  // ---- helpers for classifying an arbitrary lot end time (below) ----

  var weeklyWindowContaining = function (ts) {
    var anchor = brisbane(2026, 8, 5, 16);
    for (var k = 0; k < 700; k += 1) {
      var start = anchor + k * 7 * DAY;
      var end = start + 7 * DAY + 3 * HOUR;
      if (ts >= start - 6 * HOUR && ts <= end + 12 * HOUR) return { start: start, end: end };
      if (start - 6 * HOUR > ts) break;
    }
    return null;
  };

  var monthNameOf = function (ts) {
    try {
      return new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Brisbane', month: 'long' }).format(new Date(ts)).toLowerCase();
    } catch (e) {
      return '';
    }
  };

  var dayMonth = function (ts) {
    var day = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Brisbane', day: 'numeric' }).format(new Date(ts));
    var month = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Brisbane', month: 'short' }).format(new Date(ts)).replace('.', '').replace('Sept', 'Sep');
    return day + ' ' + month;
  };

  var formatWindow = function (start, end) {
    return dayMonth(start) + ' to ' + dayMonth(end);
  };

  var formatBrisbane = function (ts) {
    var d = new Date(ts);
    var weekday = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Brisbane', weekday: 'short' }).format(d);
    var day = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Brisbane', day: 'numeric' }).format(d);
    var month = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Brisbane', month: 'short' }).format(d).replace('.', '').replace('Sept', 'Sep');
    var hour = '', minute = '', ampm = '';
    new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Brisbane', hour: 'numeric', minute: '2-digit', hour12: true }).formatToParts(d).forEach(function (part) {
      if (part.type === 'hour') hour = part.value;
      if (part.type === 'minute') minute = part.value;
      if (part.type === 'dayPeriod') ampm = part.value.toLowerCase();
    });
    return weekday + ' ' + day + ' ' + month + ', ' + hour + ':' + minute + ampm + ' Gold Coast time';
  };

  // Classifies a lot by its end time (and optional start time) into the
  // weekly or mega event window it belongs to. Returns null when neither
  // matches so callers can render no chip rather than guessing.
  var eventFor = function (endTs, startTs) {
    if (endTs == null || startTs == null || endTs === '' || startTs === '') return null;
    endTs = Number(endTs); startTs = Number(startTs);
    if (!isFinite(endTs) || !isFinite(startTs) || endTs <= startTs) return null;
    var duration = endTs - startTs, kind;
    if (duration === 7 * DAY) kind = 'weekly';
    else if (duration === 10 * DAY) kind = 'mega';
    else return null;
    var probe = new Date(endTs + 10 * HOUR);
    var dayStart = brisbane(probe.getUTCFullYear(), probe.getUTCMonth(), probe.getUTCDate(), 0);
    if (probe.getUTCDay() !== 6 || endTs < dayStart + 16 * HOUR || endTs > dayStart + 19 * HOUR) return null;
    if (kind === 'mega') {
      var mega = finalSaturdayMega(probe.getUTCFullYear(), probe.getUTCMonth());
      if (endTs < mega.end - 3 * HOUR || endTs > mega.end) return null;
    }
    var key = kind + '-' + monthNameOf(endTs);
    return { kind: kind, label: kind === 'mega' ? '10-DAY Mega' : '7-DAY Funko Auctions', key: key,
      start: startTs, end: endTs, window: formatWindow(startTs, endTs), href: '/pages/ebay-auctions?event=' + key };
  };

  // megaWindowFor(ts): the mega auction window (start/end epoch ms) that
  // covers an arbitrary timestamp, not just "now". Added 2026-09-11 for
  // assets/frenly-auctions.js, which needs to classify a lot's startDate
  // (which is rarely "now") against the mega window, not only classify the
  // live moment the way currentMega(now) already did. Same search: probe
  // the month the timestamp falls in, and if the timestamp is past that
  // month's mega close, roll forward one month (mirrors currentMega).
  var megaWindowFor = function (ts) {
    return currentMega(ts);
  };

  // isMegaWeek(ts): true when ts falls inside the mega window that covers
  // it (inclusive of both ends).
  var isMegaWeek = function (ts) {
    var mega = megaWindowFor(ts);
    return !!(mega && ts >= mega.start && ts <= mega.end);
  };

  // ---- Monthly Card Mega (added 16 Oct 2026, changed 17 Oct 2026, Marshall) ----
  // Separate from the Funko weekly/mega rules above, which are unchanged.
  // The Card Mega runs 10 days, 4pm to 4pm Gold Coast time, about 250 cards
  // from $1, lots ending 1 minute apart from 4pm. It replaces the Card Weekly
  // that would close in the same week (the Card Weekly runs every week,
  // Friday 4pm to the next Friday 4pm).
  //
  // Each Card Mega belongs to a month key 'YYYY-MM' (month 01 to 12). A Card
  // Mega that ends in the next month still belongs to the month it opened in.
  //
  // CARD_MEGA_FIRST: no Card Mega before this month.
  // CARD_MEGA_MONTHS: per month override, checked first:
  //   { start: ms, end: ms }  exact dates
  //   { endDay: n }           ends day n of that month at 4pm, opens 10 days earlier
  //   'skip'                  no Card Mega that month
  //   'run'                   use the monthly rule even in a QUAD month
  // CARD_MEGA_MONTHLY_RULE: the rule for months with no override.
  //   'last-friday'        ends the last Friday of the month
  //   'second-last-friday' ends the Friday before the last Friday
  //   Confirmed by Marshall 17 Oct 2026: "second last Friday" of every month
  //   (December 2026 ends Fri 18 Dec, same as Lister).
  //   NOTE 18 Oct 2026: Marshall set October 2026 to Tue 20 Oct to Fri 30 Oct.
  //   30 Oct is the LAST Friday of October, not the second last (23 Oct), so
  //   October and December are carried by the explicit overrides below, not by
  //   this rule. Check the rule with Marshall before relying on it for 2027.
  // CARD_MEGA_SKIP_QUAD_MONTHS: true = no Card Mega in a month that has a
  //   QUAD (the QUAD takes that slot, Marshall 17 Oct 2026: none in November
  //   2026, QUAD Fri 27 to Mon 30 Nov). QUAD months come from the QUAD dates
  //   the site already uses (window.FrenlyEventSchedule / #FrenlyEventSchedule,
  //   built by snippets/frenly-quad-dates.liquid and the quad Frenly event
  //   entries), plus that snippet's own rule (February, May, August,
  //   November) on pages that do not print the schedule. 'run' overrides it.
  var CARD_MEGA_FIRST = { y: 2026, m: 9 }; // October 2026 (JS months count from 0)
  var CARD_MEGA_MONTHLY_RULE = 'second-last-friday'; // confirmed by Marshall 17 Oct 2026
  var CARD_MEGA_SKIP_QUAD_MONTHS = true;
  var QUAD_RULE_MONTHS = [1, 4, 7, 10]; // Feb, May, Aug, Nov: same rule as snippets/frenly-quad-dates.liquid
  var CARD_MEGA_MONTHS = {
    // First Card Mega (Marshall, 17 Oct 2026 15:37Z, replaces 27 Oct to 6 Nov): Tue 20 Oct 4pm to Fri 30 Oct 4pm Gold Coast time.
    '2026-10': { start: brisbane(2026, 9, 20, 16), end: brisbane(2026, 9, 30, 16) },
    // Dec 2026 (16 Oct 2026): ends Fri 18 Dec 4pm, opens Tue 8 Dec 4pm.
    '2026-12': { endDay: 18 }
  };
  var CARD_MEGA_DAYS = 10;

  // ---- Shared schedule (17 Oct 2026) ----
  // ONE schedule the site and Lister share: the Shopify metaobject
  // frenly_auction_schedule / current, printed by
  // snippets/frenly-auction-schedule-json.liquid as
  // <script type="application/json" id="FrenlyAuctionSchedule">. When it is
  // there, its values are used first; any missing or bad field falls back to
  // the built-in values above, field by field. Weekly Funko and Monthly Funko
  // Mega are NOT read from it (their logic stays built in).
  // Fields: see /mnt/project-files/website/v2.65/SHARED-SCHEDULE.md.
  var BUILT_IN = {
    rule: CARD_MEGA_MONTHLY_RULE, first: CARD_MEGA_FIRST, days: CARD_MEGA_DAYS,
    months: CARD_MEGA_MONTHS, skipQuad: CARD_MEGA_SKIP_QUAD_MONTHS, weeklyAnchor: null
  };
  var shared = null, sharedRead = false;
  var parseIso = function (v) { var t = typeof v === 'number' ? v : Date.parse(v); return isFinite(t) ? t : NaN; };
  var readShared = function () {
    var raw = null;
    try {
      if (root.FrenlyAuctionSchedule && typeof root.FrenlyAuctionSchedule === 'object') raw = root.FrenlyAuctionSchedule;
      else if (typeof document !== 'undefined' && document.getElementById) {
        var el = document.getElementById('FrenlyAuctionSchedule');
        if (el) raw = JSON.parse(el.textContent);
      }
    } catch (e) { raw = null; }
    if (!raw || typeof raw !== 'object') return null;
    var out = { source: 'shared' };
    if (raw.card_mega_rule === 'last-friday' || raw.card_mega_rule === 'second-last-friday') out.rule = raw.card_mega_rule;
    var fm = /^(\d{4})-(\d{2})$/.exec(String(raw.card_mega_first_month || ''));
    if (fm && +fm[2] >= 1 && +fm[2] <= 12) out.first = { y: +fm[1], m: +fm[2] - 1 };
    var dd = Number(raw.card_mega_days);
    if (isFinite(dd) && dd >= 1 && dd <= 31) out.days = Math.round(dd);
    if (typeof raw.card_mega_skip_quad_months === 'boolean') out.skipQuad = raw.card_mega_skip_quad_months;
    var ov = raw.card_mega_overrides, sk = raw.card_mega_skip_months, months = null;
    if ((ov && typeof ov === 'object' && !Array.isArray(ov)) || Array.isArray(sk)) {
      months = {};
      if (ov && typeof ov === 'object' && !Array.isArray(ov)) Object.keys(ov).forEach(function (k) {
        if (!/^\d{4}-\d{2}$/.test(k)) return;
        var o = ov[k];
        if (o === 'skip' || o === 'run') { months[k] = o; return; }
        if (!o || typeof o !== 'object') return;
        if (o.skip === true) { months[k] = 'skip'; return; }
        var st = parseIso(o.start), en = parseIso(o.end);
        if (isFinite(st) && isFinite(en) && en > st) { months[k] = { start: st, end: en }; return; }
        var ed = Number(o.endDay);
        if (isFinite(ed) && ed >= 1 && ed <= 31) { months[k] = { endDay: Math.round(ed) }; return; }
        if (o.run === true) months[k] = 'run';
      });
      if (Array.isArray(sk)) sk.forEach(function (k) {
        if (typeof k === 'string' && /^\d{4}-\d{2}$/.test(k) && !(k in months)) months[k] = 'skip';
      });
      out.months = months;
    }
    var cw = raw.weekly_cadences && raw.weekly_cadences.card_weekly;
    if (cw && typeof cw === 'object') {
      var an = parseIso(cw.anchor);
      // The anchor must be a Friday close; anything else is ignored.
      if (isFinite(an) && new Date(an + 10 * HOUR).getUTCDay() === 5) out.weeklyAnchor = an;
    }
    return out;
  };
  var cfg = function () {
    if (!sharedRead) { shared = readShared(); sharedRead = !!shared || (typeof document !== 'undefined' && document.readyState === 'complete') || typeof document === 'undefined'; }
    var s = shared || {};
    return {
      source: shared ? 'shared' : 'built-in',
      rule: s.rule || BUILT_IN.rule,
      first: s.first || BUILT_IN.first,
      days: s.days || BUILT_IN.days,
      months: s.months || BUILT_IN.months,
      skipQuad: typeof s.skipQuad === 'boolean' ? s.skipQuad : BUILT_IN.skipQuad,
      weeklyAnchor: s.weeklyAnchor || null
    };
  };
  cfg(); // read once now: the JSON tag is printed just before this script
  // For tests and for a page that loads the JSON late.
  var reloadSchedule = function () { sharedRead = false; shared = null; return cfg().source; };

  var monthKey = function (y, m) { return y + '-' + (m < 9 ? '0' : '') + (m + 1); };

  var quadMonthKeys = function () {
    var keys = {}, list = null;
    try {
      var S = root.FrenlyEventSchedule;
      if (S && S.list) list = S.list;
      else if (typeof document !== 'undefined') {
        var el = document.getElementById('FrenlyEventSchedule');
        if (el) list = JSON.parse(el.textContent);
      }
    } catch (e) { list = null; }
    (list || []).forEach(function (e) {
      if (!e || e.kind !== 'quad' || !isFinite(e.start)) return;
      var d = new Date(Number(e.start) + 10 * HOUR);
      keys[monthKey(d.getUTCFullYear(), d.getUTCMonth())] = true;
    });
    return keys;
  };

  var isQuadMonth = function (y, m) {
    return QUAD_RULE_MONTHS.indexOf(m) !== -1 || !!quadMonthKeys()[monthKey(y, m)];
  };

  var fridayEnd = function (y, m, rule) {
    var last = new Date(Date.UTC(y, m + 1, 0));
    var d = last.getUTCDate() - (last.getUTCDay() + 2) % 7; // last Friday
    if (rule === 'second-last-friday') d -= 7;
    return brisbane(y, m, d, 16);
  };

  var cardMegaFor = function (y, m) {
    var c = cfg();
    if (y < c.first.y || (y === c.first.y && m < c.first.m)) return null;
    var o = c.months[monthKey(y, m)], end;
    if (o === 'skip') return null;
    if (o && typeof o === 'object' && isFinite(o.start) && isFinite(o.end)) return { start: o.start, end: o.end, month: monthKey(y, m) };
    if (o !== 'run' && c.skipQuad && isQuadMonth(y, m)) return null;
    if (o && typeof o === 'object' && o.endDay) end = brisbane(y, m, o.endDay, 16);
    else end = fridayEnd(y, m, c.rule);
    return { start: end - c.days * DAY, end: end, month: monthKey(y, m) };
  };

  // The Card Mega that is on now, or the next one, at `now` (null if none
  // found). Starts one month back, because a Card Mega can end in the month
  // after the month it belongs to.
  var currentCardMega = function (now) {
    var probe = new Date(now + 10 * HOUR), y = probe.getUTCFullYear(), m = probe.getUTCMonth() - 1;
    if (m < 0) { m = 11; y -= 1; }
    for (var i = 0; i < 26; i += 1) {
      var c = cardMegaFor(y, m);
      if (c && c.end > now) return c;
      m += 1; if (m > 11) { m = 0; y += 1; }
    }
    return null;
  };

  // The Card Mega that ends inside a Card Weekly window (start, end], or null.
  // A Card Weekly with a non-null result is replaced by that Card Mega.
  var cardMegaInWeek = function (start, end) {
    var a = new Date(start + 10 * HOUR), b = new Date(end + 10 * HOUR);
    var py = a.getUTCFullYear(), pm = a.getUTCMonth() - 1;
    if (pm < 0) { pm = 11; py -= 1; }
    var list = [cardMegaFor(py, pm), cardMegaFor(a.getUTCFullYear(), a.getUTCMonth()), cardMegaFor(b.getUTCFullYear(), b.getUTCMonth())];
    for (var i = 0; i < list.length; i += 1) if (list[i] && list[i].end > start && list[i].end <= end) return list[i];
    return null;
  };

  // The Card Mega whose closing evening contains `ts` (a lot or event end
  // time), or null. Lots end 1 minute apart from 4pm, so the evening runs
  // to 6am the next morning, the same day rule the feed waves use. Used to
  // name a finished or live card wave by its DATES, never by its lot count.
  var cardMegaEndingOn = function (ts) {
    if (!isFinite(ts)) return null;
    var dayOf = function (x) { return Math.floor((x + 10 * HOUR - 6 * HOUR) / DAY); };
    var p = new Date(ts + 10 * HOUR), y = p.getUTCFullYear(), m = p.getUTCMonth() - 1;
    if (m < 0) { m = 11; y -= 1; }
    for (var i = 0; i < 2; i += 1) {
      var c = cardMegaFor(y, m);
      if (c && dayOf(c.end) === dayOf(ts)) return c;
      m += 1; if (m > 11) { m = 0; y += 1; }
    }
    return null;
  };

  // ---- Card Weekly (17 Oct 2026, changed 18 Oct 2026, Marshall) ----
  // 7 days, Friday 4pm to the next Friday 4pm Gold Coast time. 18 Oct 2026 (Marshall: "this starts on
  // the 30th and runs 7 days after that ... there wouldnt be one where the quad is"): there is NO Card
  // Weekly while a Card Mega runs or while the QUAD runs. A week is skipped when its window overlaps
  // the Card Mega window or the QUAD window at all. So: Card Mega 20 to 30 Oct, then Card Weekly
  // 30 Oct to 6 Nov, 6 to 13 Nov, 13 to 20 Nov, none while the QUAD runs (27 to 30 Nov), none while
  // the December Card Mega runs (8 to 18 Dec), then 18 to 25 Dec.
  // The shared schedule can switch either skip off:
  //   weekly_cadences.card_weekly.skip_while_card_mega_runs: false = only skip the week it ends in (old rule)
  //   weekly_cadences.card_weekly.skip_quad_weeks: false = run through the QUAD
  var CARD_WEEKLY_ANCHOR = brisbane(2026, 9, 2, 16); // a Friday 4pm close (Fri 2 Oct 2026)
  // Single weeks Marshall cancelled, by opening day 'YYYY-MM-DD' (Gold Coast). The shared schedule's
  // weekly_cadences.card_weekly.skip_weeks adds to this list.
  // 18 Oct 2026 (Marshall, via Lister): no Card Weekly 18 to 25 Dec, the Mega takes it.
  var CARD_WEEKLY_SKIP = ['2026-12-18'];
  var QUAD_SECONDS = 309600; // Friday 9am to Monday 10pm, same as snippets/frenly-quad-dates.liquid

  // QUAD windows near ts: the printed schedule first, else the snippet's own rule.
  var quadRule = function (y, m) {
    var start;
    if (m === 10) { // November: Black Friday, the day after the 4th Thursday
      var dow1 = new Date(Date.UTC(y, 10, 1)).getUTCDay();
      var thu = 1 + (4 - dow1 + 7) % 7 + 21;
      start = brisbane(y, 10, thu + 1, 9);
    } else { // the last Friday of the month
      var last = new Date(Date.UTC(y, m + 1, 0));
      start = brisbane(y, m, last.getUTCDate() - (last.getUTCDay() + 2) % 7, 9);
    }
    return { start: start, end: start + QUAD_SECONDS * 1000 };
  };
  var quadWindows = function (ts) {
    var out = [], list = null;
    try {
      var S = root.FrenlyEventSchedule;
      if (S && S.list) list = S.list;
      else if (typeof document !== 'undefined' && document.getElementById) {
        var el = document.getElementById('FrenlyEventSchedule');
        if (el) list = JSON.parse(el.textContent);
      }
    } catch (e) { list = null; }
    var printed = {};
    (list || []).forEach(function (e) {
      if (!e || e.kind !== 'quad' || !isFinite(e.start) || !isFinite(e.end)) return;
      out.push({ start: Number(e.start), end: Number(e.end) });
      var d = new Date(Number(e.start) + 10 * HOUR);
      printed[monthKey(d.getUTCFullYear(), d.getUTCMonth())] = true;
    });
    var p = new Date(ts + 10 * HOUR), y = p.getUTCFullYear();
    [y - 1, y, y + 1].forEach(function (yy) {
      QUAD_RULE_MONTHS.forEach(function (m) { if (!printed[monthKey(yy, m)]) out.push(quadRule(yy, m)); });
    });
    return out;
  };
  // The Card Mega whose window overlaps (start, end), or null.
  var cardMegaOverlapping = function (start, end) {
    var p = new Date(start + 10 * HOUR), y = p.getUTCFullYear(), m = p.getUTCMonth() - 1;
    if (m < 0) { m = 11; y -= 1; }
    for (var i = 0; i < 3; i += 1) {
      var c = cardMegaFor(y, m);
      if (c && c.start < end && c.end > start) return c;
      m += 1; if (m > 11) { m = 0; y += 1; }
    }
    return null;
  };
  var cardWeeklyRules = function () {
    var raw = null;
    try {
      if (root.FrenlyAuctionSchedule && typeof root.FrenlyAuctionSchedule === 'object') raw = root.FrenlyAuctionSchedule;
      else if (typeof document !== 'undefined' && document.getElementById) {
        var el = document.getElementById('FrenlyAuctionSchedule');
        if (el) raw = JSON.parse(el.textContent);
      }
    } catch (e) { raw = null; }
    var cw = raw && raw.weekly_cadences && raw.weekly_cadences.card_weekly;
    var skip = CARD_WEEKLY_SKIP.slice();
    if (cw && Array.isArray(cw.skip_weeks)) cw.skip_weeks.forEach(function (d) { if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}/.test(d)) skip.push(d.slice(0, 10)); });
    return {
      whileMega: !(cw && cw.skip_while_card_mega_runs === false),
      quad: !(cw && cw.skip_quad_weeks === false),
      skip: skip
    };
  };
  // Why a Card Weekly window does not run: 'cardmega', 'quad' or '' (it runs).
  var cardWeeklySkip = function (start, end) {
    var r = cardWeeklyRules();
    if (r.skip.indexOf(new Date(start + 10 * HOUR).toISOString().slice(0, 10)) !== -1) return 'cancelled';
    if (r.whileMega ? cardMegaOverlapping(start, end) : cardMegaInWeek(start, end)) return 'cardmega';
    if (r.quad && quadWindows(start).some(function (q) { return q.start < end && q.end > start; })) return 'quad';
    return '';
  };
  // The Card Weekly that is on now, or the next one (null if none in 26 weeks).
  var cardWeeklyFor = function (now) {
    var anchor = cfg().weeklyAnchor || CARD_WEEKLY_ANCHOR;
    var k = Math.floor((now - anchor) / (7 * DAY)) + 1;
    for (var i = 0; i < 26; i += 1, k += 1) {
      var end = anchor + k * 7 * DAY, start = end - 7 * DAY;
      if (end <= now || cardWeeklySkip(start, end)) continue;
      return { start: start, end: end };
    }
    return null;
  };
  // The next Card Weekly that has not opened yet. Uploads never go into a running auction
  // (Lister rule), so a running week with no lots in the feed is not on: show this one instead.
  var cardWeeklyNext = function (now) {
    var w = cardWeeklyFor(now);
    while (w && w.start <= now) w = cardWeeklyFor(w.end);
    return w;
  };
  // The next n Card Weekly windows that have not opened yet (for Lister folders and the calendar).
  var cardWeeklyList = function (now, n) {
    var out = [], w = cardWeeklyNext(now);
    while (w && out.length < (n || 8)) { out.push(w); w = cardWeeklyFor(w.end); }
    return out;
  };

  root.FrenlyCadence = {
    brisbane: brisbane,
    finalSaturdayMega: finalSaturdayMega,
    currentMega: currentMega,
    currentWeekly: currentWeekly,
    megaWindowFor: megaWindowFor,
    isMegaWeek: isMegaWeek,
    eventFor: eventFor,
    cardMegaFor: cardMegaFor,
    currentCardMega: currentCardMega,
    cardMegaInWeek: cardMegaInWeek,
    cardMegaEndingOn: cardMegaEndingOn,
    cardWeeklyFor: cardWeeklyFor,
    cardWeeklyNext: cardWeeklyNext,
    cardWeeklyList: cardWeeklyList,
    cardWeeklySkip: cardWeeklySkip,
    quadWindows: quadWindows,
    isQuadMonth: isQuadMonth,
    CARD_MEGA_MONTHLY_RULE: CARD_MEGA_MONTHLY_RULE,
    cardMegaRule: function () { return cfg().rule; },
    scheduleSource: function () { return cfg().source; },
    reloadSchedule: reloadSchedule,
    formatWindow: formatWindow,
    formatBrisbane: formatBrisbane
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = root.FrenlyCadence;
  }
})(typeof window !== 'undefined' ? window : (typeof global !== 'undefined' ? global : this));
